import script from "./Payment-Verification.vue?vue&type=script&setup=true&lang=js"
export * from "./Payment-Verification.vue?vue&type=script&setup=true&lang=js"

import "./Payment-Verification.vue?vue&type=style&index=0&id=5aeb9c91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aeb9c91"]])

export default __exports__